import i18n from '../i18n';

/** Resolve UI copy outside React components (toasts, utils, stores). */
export function translate(
  key: string,
  options?: Record<string, unknown>,
): string {
  return i18n.t(key, options);
}
